import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {State} from '../../reducers'
import {PerfilUsuario} from '../../interfaces/perfil-usuario.interface'
import {KEYS} from '../../constants/keysStorage'
import {AnimatePresence, motion} from 'framer-motion/dist/framer-motion'
import ModalContacto from '../ContactoSoporte/ModalContacto'
import {
  ClienteContexto,
  TipoContacto,
  buildWhatsAppMessage,
  getWhatsAppConfig,
  getAmbiente,
  openWhatsApp,
} from '../../utils/whatsapp.utils'

import PhoneIcon from '../../media/felsv/DarkPhone.svg'
import DarkInvoice from '../../media/felsv/dark_invoice_icon.svg'
import WhiteInvoice from '../../media/felsv/white_invoice_icon.svg'
import HelpIcon from '../../media/felsv/help-circle-svgrepo-com.svg'
import DarkUsers from '../../media/felsv/dark_users_icon.svg'
import WhiteUsers from '../../media/felsv/WhiteAgregarUsuario.svg'

interface OpcionContacto {
  tipo: TipoContacto
  titulo: string
  descripcion: string
  darkIcon: string
  whiteIcon: string
}

const OPCIONES: OpcionContacto[] = [
  {
    tipo: 'ventas',
    titulo: 'Hablar con Ventas',
    descripcion: 'Orientación comercial, planes y acompañamiento.',
    darkIcon: DarkInvoice,
    whiteIcon: WhiteInvoice,
  },
  {
    tipo: 'soporte',
    titulo: 'Solicitar Soporte',
    descripcion: 'Envía tus datos y detalla el inconveniente para atención rápida.',
    darkIcon: HelpIcon,
    whiteIcon: HelpIcon,
  },
  {
    tipo: 'gerencia',
    titulo: 'Escalar con Gerencia',
    descripcion: 'Casos urgentes o sensibles que requieren seguimiento de mayor nivel.',
    darkIcon: DarkUsers,
    whiteIcon: WhiteUsers,
  },
]

const FloatingContactButton = () => {
  const [abierto, setAbierto] = useState(false)
  const [modalTipo, setModalTipo] = useState<TipoContacto | null>(null)
  const [hoveredCard, setHoveredCard] = useState<TipoContacto | null>(null)

  const {datos, width = 1000} = useSelector((state: State) => state.userLogin)
  const profileData: PerfilUsuario = useSelector(
    (state: State) => state.gestionUsuario.perfilUsuario
  )

  const buildContexto = (): ClienteContexto => {
    const sucursalActiva = profileData?.sucursales?.find((s: any) => s.sucursal_seleccionada)
    return {
      cliente: datos?.company || localStorage.getItem(KEYS.NAME_CLIENT) || 'No definido',
      codigoEmpresa:
        datos?.codigo_empresa || localStorage.getItem(KEYS.CODIGO_EMPRESA) || 'No definido',
      usuario: datos?.username || 'No definido',
      sucursal:
        (sucursalActiva as any)?.Sucursal?.nombre ||
        (datos?.sucursal_seleccionada ? `ID: ${datos.sucursal_seleccionada}` : 'No definido'),
      nombreCompleto:
        [datos?.first_name, datos?.last_name].filter(Boolean).join(' ').trim() || 'No definido',
      ambiente: getAmbiente(),
    }
  }

  const handleOpcion = (tipo: TipoContacto) => {
    if (tipo === 'ventas') {
      const contexto = buildContexto()
      const config = getWhatsAppConfig()
      const mensaje = buildWhatsAppMessage('ventas', contexto, {
        tipoAyuda: '',
        mensajeAdicional: 'Interesado en conocer más sobre FELES.',
      })
      openWhatsApp(config.ventas, mensaje)
    } else {
      setModalTipo(tipo)
    }
  }

  const handleCerrarTodo = () => {
    setAbierto(false)
    setModalTipo(null)
  }

  const handleCerrarFormulario = () => {
    setModalTipo(null)
  }

  return (
    <>
      {/* Botón flotante */}
      <button
        onClick={() => setAbierto(prev => !prev)}
        title='Contacto y soporte'
        style={{
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          height: '44px',
          width: width <= 479 ? '44px' : 'auto',
          borderRadius: width <= 479 ? '50%' : '24px',
          padding: width <= 479 ? '0' : '0 20px',
          gap: '8px',
          background: '#13AD90',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 16px rgba(19, 173, 144, 0.45)',
          zIndex: 1000,
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          color: '#fff',
          fontWeight: 600,
          fontSize: '14px',
        }}
        onMouseOver={e => {
          ;(e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.05)'
          ;(e.currentTarget as HTMLButtonElement).style.boxShadow =
            '0 6px 24px rgba(19, 173, 144, 0.6)'
        }}
        onMouseOut={e => {
          ;(e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)'
          ;(e.currentTarget as HTMLButtonElement).style.boxShadow =
            '0 4px 16px rgba(19, 173, 144, 0.45)'
        }}
      >
        <img
          src={PhoneIcon}
          alt='Soporte'
          width='20'
          height='20'
          style={{filter: 'brightness(0) invert(1)', flexShrink: 0}}
        />
        {width > 479 && <span>Soporte</span>}
      </button>

      {/* Modal selector de contacto */}
      <AnimatePresence>
        {abierto && !modalTipo && (
          <div
            className='modal-base-bg modal-base overlay-base'
            onClick={handleCerrarTodo}
            style={{zIndex: 1001, justifyContent: 'center', alignItems: 'center', padding: '16px'}}
          >
            <motion.div
              initial={{opacity: 0, scale: 0.95, y: 20}}
              animate={{opacity: 1, scale: 1, y: 0}}
              exit={{opacity: 0, scale: 0.95, y: 20}}
              transition={{duration: 0.2}}
              onClick={e => e.stopPropagation()}
              style={{
                background: '#fff',
                borderRadius: '12px',
                padding: '28px 24px 20px',
                width: '100%',
                maxWidth: '680px',
                maxHeight: '90vh',
                overflowY: 'auto',
                boxShadow: '0 8px 40px rgba(9, 22, 56, 0.12)',
              }}
            >
              {/* Encabezado */}
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px'}}>
                <div>
                  <h3 className='card-title l' style={{margin: 0}}>
                    Contacto y Soporte
                  </h3>
                  <p className='card-description' style={{margin: '4px 0 0', fontSize: '13px', color: '#6b7280'}}>
                    Elige cómo quieres contactarnos
                  </p>
                </div>
                <button
                  onClick={handleCerrarTodo}
                  style={{background: 'none', border: 'none', cursor: 'pointer', padding: '4px', lineHeight: 1}}
                >
                  <span style={{fontSize: '20px', color: '#6b7280', fontWeight: 300}}>✕</span>
                </button>
              </div>

              <div className='form-separator' style={{margin: '16px 0'}}></div>

              {/* Tarjetas de opción */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
                  gap: '16px',
                }}
              >
                {OPCIONES.map(opcion => {
                  const isHovered = hoveredCard === opcion.tipo
                  return (
                    <button
                      key={opcion.tipo}
                      type='button'
                      className='dashboard-card w-inline-block'
                      onClick={() => handleOpcion(opcion.tipo)}
                      onMouseEnter={() => setHoveredCard(opcion.tipo)}
                      onMouseLeave={() => setHoveredCard(null)}
                      style={{border: 'none', cursor: 'pointer', textAlign: 'left', width: '100%'}}
                    >
                      <img
                        src={isHovered ? opcion.whiteIcon : opcion.darkIcon}
                        alt={opcion.titulo}
                        width='28'
                        height='28'
                      />
                      <h2 className='dashboard-card-title l'>{opcion.titulo}</h2>
                      <p className='card-description m'>{opcion.descripcion}</p>
                      <span style={{fontSize: '13px', fontWeight: 600, marginTop: '8px', display: 'block'}}>
                        {opcion.tipo === 'ventas'
                          ? 'Abrir WhatsApp ↗'
                          : opcion.tipo === 'gerencia'
                          ? 'Redactar correo ↗'
                          : 'Continuar →'}
                      </span>
                    </button>
                  )
                })}
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

      {/* Formulario de soporte o gerencia */}
      {abierto && modalTipo && modalTipo !== 'ventas' && (
        <ModalContacto
          tipo={modalTipo}
          contexto={buildContexto()}
          onClose={handleCerrarFormulario}
        />
      )}
    </>
  )
}

export default FloatingContactButton
